import { action, makeObservable, observable } from "mobx";
import ImpactsApi, { ImpactsApi as IImpactsApi } from "../../../../../../../../services/api/v2/impacts/Impacts.api";

export class StakeholderEmailsModel {
  itemIds: number[];
  @observable stakeholders: any = [];
  @observable isLoading: boolean = true;
  organisationId: number;
  projectId: number;
  impactsProvider: IImpactsApi;

  constructor(organisationId: number, projectId: number, itemIds: number[]) {
    makeObservable(this);
    this.itemIds = itemIds;
    this.impactsProvider = ImpactsApi;
    this.projectId = projectId;
    this.organisationId = organisationId;
  }

  onMount = async () => {
    await this.loadImpacts();
  };

  loadImpacts = async () => {
    let res = await this.impactsProvider.getStakeholderEmailsByImpactIds(
      this.organisationId,
      this.projectId,
      this.itemIds
    );
    if (!res || res.isError) return;
    this.setStakeholders(res.payload);
    this.setIsLoading(false);
  };

  @action
  setStakeholders = stakeholders => {
    this.stakeholders = stakeholders;
  };

  @action
  setIsLoading = isLoading => {
    this.isLoading = isLoading;
  };
}
